<template>
    <rkm-modal
        extra-large
        ref="RkmModal"
        title="Vínculo - Material (ConectaSUS)"
    >
        <rkm-form
            v-if="model"
            ref="RkmForm"
            show-legend
        >
            <rkm-row>
                <rkm-col cols="12">
                    <rkm-form-input
                        disabled
                        :value="model.nome"
                        label="Material (Cliente)"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="4">
                    <rkm-form-select
                        :options="form.conectasusGrupos"
                        @change="model.conectasusMaterial = null"
                        default-option-text="Todos"
                        label="Grupo (ConectaSUS)"
                        show-default-option
                        text-field="nome"
                        v-model="model.conectasusMaterialGrupoId"
                        value-field="id"
                    />
                </rkm-col>

                <rkm-col cols="8">
                    <rkm-form-input-autocomplete
                        :repository="repositories.cadastroMaterial"
                        :request-query-string-params="{grupo_id: model.conectasusMaterialGrupoId}"
                        :search-fields="fields.conectasusMaterial"
                        :validations="validations.conectasusMaterial"
                        label="Material (ConectaSUS)"
                        text-field="descricaoCompleta"
                        uppercase
                        v-model="model.conectasusMaterial"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <template v-slot:footer="{cancel}">
            <rkm-button @click="cancel">
                Fechar
            </rkm-button>

            <rkm-button
                color="primary"
                @click="save"
            >
                Salvar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Mixins.
import {error, repository, stringCase, unmask} from '@/mixins'

// Vuex.
import {mapActions} from 'vuex'

export default {
    computed: {
        validations() {
            return {
                conectasusMaterial: {required: true},
            }
        },
        fields() {
            return {
                conectasusMaterial: [
                    { key: 'codigo_material', searchable: true },
                    { key: 'descricao', searchable: true },
                ],
            }
        },
    },
    created() {
        this.repositories = {
            cadastroGrupo: this.getConectaSusRepository('cadastro.grupo'),
            cadastroMaterial: this.getConectaSusRepository('cadastro.material'),
            material: this.getConectaSusRepository('webService.almoxarifado.cliente.material'),
        }
    },
    data: () => ({
        materialId: null,
        form: null,
        model: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(materialId) {
            this.materialId = materialId
            this.form = null
            this.model = null

            this.load()
            this.$refs.RkmModal.show()
        },
        load() {
            this.setLoading()

            this.repositories.material.edit(this.materialId)
                .then(response => {
                    this.form = Object.assign(response.data.form)
                    this.model = Object.assign(response.data.model)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    this.setLoading()

                    const request = {
                        nome: this.model.nome,
                        conectasusMaterialId: this.model.conectasusMaterial?.id ?? null,
                    }

                    this.repositories.material.update(this.materialId, this.camelObjectKeysToSnakeRecursive(request))
                        .then(response => {
                            this.showSaveNotification()
                            this.$emit('saved', response)
                            this.$refs.RkmModal.hide()
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
    },
    mixins: [error, repository, stringCase, unmask],
}
</script>